import { InventoryAdjustmentListPage } from '@/features/inventory-adjustment/pages/InventoryAdjustmentListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentListPage,
})
